module.exports = __webpack_public_path__ + "static/media/cashier-machine.87591ce1.svg";